import { QueryHookOptions, useQuery } from '@apollo/client';
import { GET_CREATOR_TASKS_CONFIG } from '../queries/CreatorTasksConfig';
import { GetCreatorTasksConfig, GetCreatorTasksConfigVariables } from '../queries/types/GetCreatorTasksConfig';

type Options = QueryHookOptions<GetCreatorTasksConfig, GetCreatorTasksConfigVariables>;

export const useGetCreatorTasksConfig = (options: Options) => {
  const { data, loading, error } = useQuery(GET_CREATOR_TASKS_CONFIG, options);

  return {
    creatorTasksConfigs: data?.creatorTasksConfigs,
    isCreatorTasksConfigLoading: loading,
    creatorTasksConfigError: error,
  };
};
